import '../__generated__/styles/text.css';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import clsx from 'clsx';
import _extends from '@babel/runtime/helpers/esm/extends';
import { useTheme } from '@paypalcorp/pp-react-theme';
import { Shimmer } from '@paypalcorp/pp-react-utils';

var styles = {"ppvx_text--xl8":"ppvx_text--xl8___5-9-6","ppvx_text--xl7":"ppvx_text--xl7___5-9-6","ppvx_text--xl6":"ppvx_text--xl6___5-9-6","ppvx_text--xl5":"ppvx_text--xl5___5-9-6","ppvx_text--xl4":"ppvx_text--xl4___5-9-6","ppvx_text--xl3":"ppvx_text--xl3___5-9-6","ppvx_text--xl2":"ppvx_text--xl2___5-9-6","ppvx_text--xl":"ppvx_text--xl___5-9-6","ppvx_text--lg":"ppvx_text--lg___5-9-6","ppvx_text--md":"ppvx_text--md___5-9-6","ppvx_text--sm":"ppvx_text--sm___5-9-6","ppvx_text--xs":"ppvx_text--xs___5-9-6","ppvx_text--regular":"ppvx_text--regular___5-9-6","ppvx_text--medium":"ppvx_text--medium___5-9-6","ppvx_text--caption":"ppvx_text--caption___5-9-6","ppvx_text--caption-strong":"ppvx_text--caption-strong___5-9-6","ppvx_text--body":"ppvx_text--body___5-9-6","ppvx_text--body-strong":"ppvx_text--body-strong___5-9-6","ppvx_text--heading-xs":"ppvx_text--heading-xs___5-9-6","ppvx_text--heading-sm":"ppvx_text--heading-sm___5-9-6","ppvx_text--heading-md":"ppvx_text--heading-md___5-9-6","ppvx_text--heading-lg":"ppvx_text--heading-lg___5-9-6","ppvx_text--hero":"ppvx_text--hero___5-9-6","ppvx_text--beta-title":"ppvx_text--beta-title___5-9-6","ppvx_text--beta-heading-xs":"ppvx_text--beta-heading-xs___5-9-6","ppvx_text--beta-heading-sm":"ppvx_text--beta-heading-sm___5-9-6","ppvx_text--beta-heading-md":"ppvx_text--beta-heading-md___5-9-6","ppvx_text--beta-heading-lg":"ppvx_text--beta-heading-lg___5-9-6","ppvx_text--beta-display-lg":"ppvx_text--beta-display-lg___5-9-6","ppvx_text--shimmer":"ppvx_text--shimmer___5-9-6","ppvx--v2":"ppvx--v2___5-9-6","ppvx--v1":"ppvx--v1___5-9-6","ppvx_line-clamp":"ppvx_line-clamp___5-9-6","ppvx_line-clamp--line-1":"ppvx_line-clamp--line-1___5-9-6","ppvx_line-clamp--line-2":"ppvx_line-clamp--line-2___5-9-6","ppvx_line-clamp--line-3":"ppvx_line-clamp--line-3___5-9-6","ppvx_line-clamp--line-4":"ppvx_line-clamp--line-4___5-9-6"};

var _excluded = ["as", "size", "regular", "medium", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Text(_ref) {
  var _clsx;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'p' : _ref$as,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      regular = _ref.regular,
      medium = _ref.medium,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(as, _objectSpread({
    className: clsx(styles["ppvx_text--".concat(size)], (_clsx = {}, _defineProperty(_clsx, styles['ppvx_text--regular'], regular), _defineProperty(_clsx, styles['ppvx_text--medium'], medium), _clsx), className)
  }, rest));
}

var _excluded$1 = ["level", "as", "size", "className", "theme", "isLoading", "isInverse", "children"];

var chooseSize = function (level, isV2, size) {
  if (size) {
    return size;
  }

  if (isV2) {
    // v2  mapping 'lg' and 'sm'
    switch (level) {
      case 1:
        return 'lg';

      case 2:
        return 'sm';

      /* istanbul ignore next */

      default:
        return 'lg';
    }
  } // v1 mapping


  switch (level) {
    case 1:
      return 'lg';

    case 2:
      return 'md';

    case 3:
      return 'sm';

    /* istanbul ignore next */

    default:
      return 'md';
  }
};

var HeadingText = function (_ref) {
  var _clsx;

  var level = _ref.level,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? level ? "h".concat(level) : 'div' : _ref$as,
      size = _ref.size,
      className = _ref.className,
      theme = _ref.theme,
      isLoading = _ref.isLoading,
      isInverse = _ref.isInverse,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  // get theme from themeContext, otherwise use theme
  var _theme = useTheme('HeadingText', theme);

  var isV2 = _theme && _theme === 'v2';
  var headingSize = chooseSize(level, isV2, size);
  var cls = clsx((_clsx = {}, _defineProperty(_clsx, styles["ppvx_text--heading-".concat(headingSize)], headingSize !== 'hero'), _defineProperty(_clsx, styles['ppvx_text--hero'], headingSize === 'hero'), _clsx), className, isV2 && styles['ppvx--v2'], isV2 && isLoading && styles['ppvx_text--shimmer']);

  if (isV2 && isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, {
      className: cls,
      hasStyleDefaults: false,
      isInverse: isInverse
    }, children);
  }

  return /*#__PURE__*/React.createElement(as, _extends({
    className: cls
  }, rest), children);
};

var _excluded$2 = ["as", "strong", "className", "theme", "isLoading", "isInverse", "clampAtLine", "children"];

var BodyText = function (_ref) {
  var _clsx;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      strong = _ref.strong,
      className = _ref.className,
      theme = _ref.theme,
      isLoading = _ref.isLoading,
      isInverse = _ref.isInverse,
      clampAtLine = _ref.clampAtLine,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  // get theme from themeContext, otherwise use theme
  var _theme = useTheme('BodyText', theme);

  var isV2 = _theme && _theme === 'v2';
  var cls = clsx((_clsx = {}, _defineProperty(_clsx, styles['ppvx_text--body'], !strong), _defineProperty(_clsx, styles['ppvx_text--body-strong'], strong), _defineProperty(_clsx, styles["ppvx_line-clamp--line-".concat(clampAtLine)], clampAtLine), _clsx), className, isV2 && styles['ppvx--v2'], isV2 && isLoading && styles['ppvx_text--shimmer']);

  if (isV2 && isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, {
      className: cls,
      hasStyleDefaults: false,
      isInverse: isInverse
    }, children);
  }

  return /*#__PURE__*/React.createElement(as, _extends({
    className: cls
  }, rest), children);
};

var _excluded$3 = ["as", "strong", "clampAtLine", "className", "theme", "isLoading", "isInverse", "children"];

var CaptionText = function (_ref) {
  var _clsx;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      strong = _ref.strong,
      clampAtLine = _ref.clampAtLine,
      className = _ref.className,
      theme = _ref.theme,
      isLoading = _ref.isLoading,
      isInverse = _ref.isInverse,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$3);

  // get theme from themeContext, otherwise use theme
  var _theme = useTheme('CaptionText', theme);

  var isV2 = _theme && _theme === 'v2';
  var cls = clsx((_clsx = {}, _defineProperty(_clsx, styles['ppvx_text--caption'], !strong), _defineProperty(_clsx, styles['ppvx_text--caption-strong'], strong), _defineProperty(_clsx, styles["ppvx_line-clamp--line-".concat(clampAtLine)], clampAtLine), _clsx), className, isV2 && styles['ppvx--v2'], isV2 && isLoading && styles['ppvx_text--shimmer']);

  if (isV2 && isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, {
      className: cls,
      hasStyleDefaults: false,
      isInverse: isInverse
    }, children);
  }

  return /*#__PURE__*/React.createElement(as, _extends({
    className: cls
  }, rest), children);
};

var _excluded$4 = ["as", "className", "theme"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function BetaTitleText(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded$4);

  // get theme from themeContext, otherwise use theme
  var _theme = useTheme('BetaTitleText', theme);

  return React.createElement(as, _objectSpread$1({
    className: clsx(styles['ppvx_text--beta-title'], className, _theme && _theme === 'v2' && styles['ppvx--v2'])
  }, rest));
}

var _excluded$5 = ["as", "size", "className", "theme"];

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function BetaHeadingText(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      size = _ref.size,
      className = _ref.className,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded$5);

  // get theme from themeContext, otherwise use theme
  var _theme = useTheme('BetaHeadingText', theme);

  return React.createElement(as, _objectSpread$2({
    className: clsx(styles["ppvx_text--beta-heading-".concat(size)], className, _theme && _theme === 'v2' && styles['ppvx--v2'])
  }, rest));
}

var _excluded$6 = ["as", "size", "className", "theme"];

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function BetaDisplayText(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      size = _ref.size,
      className = _ref.className,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded$6);

  // get theme from themeContext, otherwise use theme
  var _theme = useTheme('BetaDisplayText', theme);

  return React.createElement(as, _objectSpread$3({
    className: clsx(styles["ppvx_text--beta-display-".concat(size)], className, _theme && _theme === 'v2' && styles['ppvx--v2'])
  }, rest));
}

export { BetaDisplayText, BetaHeadingText, BetaTitleText, BodyText, CaptionText, HeadingText, Text };
